// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".6c1b1e80ae1d5b9bc343dd545ae57d4a1fec1aab.chunk.js";
};